//#region Libraries
import { useState } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { 
    Container,
    ActionsCell,
    TDef, 
    TDefContent } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import EditIcon from "icons/EditIcon";
import TrashIcon from "icons/TrashIcon";
import { 
    UserCell, NameCell, 
    CategoryCell, RoleCell } from "./styles";
import { useEffect } from "react";
//#endregion
//#region Utils
//#endregion

const TDEF_CONTENT_PROPS = {
    margin: "1px 0"
};

const TableListItem = ({
    user,
    name,
    surname,
    category,
    role,
    creationDate,
    newlyAddedOrUpdatedUser,
    filterFields,
    currentUser,
    openForm,
    showForm,
    openDialogForDeleteUser
}) => {
    const isNewlyAddedOrUpdatedUser = newlyAddedOrUpdatedUser?.userObj.user === user;
    //#region States
    const [mouseInRow, setMouseInRow] = useState(false);
    //#endregion
    //#region Functions
    const getClassName = {
        cell: () => {
            const classList = ["small"];
            return classList.join(" ");
        },
        userCell: user => {
            const classList = ["small"];
            // Verificando si el cursor del mouse está en la fila o se ha abierto el form de edición
            if (mouseInRow || (showForm && currentUser?.user === user))
                classList.push("active");
            isNewlyAddedOrUpdatedUser && classList.push("created-or-updated");
            return classList.join(" ");
        },
        actionsCell: () => {
            const classList = ["small"];
            return classList.join(" ");
        }
    };
    const renderText = ({
        filterKey, 
        cellKey,
        compareValue, value
    }) => {
        // Resaltando en bold las celdas que están relacionadas con un usuario recién agregado o actualizado
        if (isNewlyAddedOrUpdatedUser) {
            if (newlyAddedOrUpdatedUser.changes === null ||
                (newlyAddedOrUpdatedUser.changes === null && !cellKey) || 
                newlyAddedOrUpdatedUser.changes[cellKey])
                return <b>{value}</b>
        }
        if (!cellKey) 
            return value;
        if (filterKey === "nameSurnameOrUser") {
            const nameSurnameOrUserTrimmedAndSplitted = filterFields.nameSurnameOrUser.split(" ").filter(ch => ch.trim() !== "");
            if (compareValue.split(" ").some(word => nameSurnameOrUserTrimmedAndSplitted.includes(word)))
                return <b>{value}</b>
        }
        else if (filterFields[filterKey] === compareValue)
            return (
                <b>{value}</b>
            );
        return value;
    }
    //#endregion
    const propsAdminActionsCell = {
        className: getClassName.actionsCell(),
        minWidth: "100px"
    };
    const propsForCell = {
        ...TDEF_CONTENT_PROPS,
        className: getClassName.cell()
    };
    const userObj = {
        name, surname,
        user, category, role
    };
    return (
        <Container onMouseEnter={() => setMouseInRow(true)} onMouseLeave={() => setMouseInRow(false)}>
            <TDef>
                <UserCell 
                    {...TDEF_CONTENT_PROPS}
                    className={getClassName.userCell(user)}>
                    <h5 title={user}>{renderText({
                        key: "nameSurnameOrUser", 
                        cellKey: "user",
                        compareValue: user, 
                        value: user
                    })}</h5>
                </UserCell>
            </TDef>
            <TDef>
                <NameCell {...propsForCell}>
                    <h5 title={name}>{renderText({
                        filterKey: "nameSurnameOrUser", 
                        cellKey: "name",
                        compareValue: name, 
                        value: name
                    })}</h5>
                </NameCell>
            </TDef>
            <TDef>
                <NameCell {...propsForCell}>
                    <h5 title={surname}>{renderText({
                        filterKey: "nameSurnameOrUser", 
                        cellKey: "surname",
                        compareValue: surname, 
                        value: surname
                    })}</h5>
                </NameCell>
            </TDef>
            <TDef>
                <CategoryCell {...propsForCell}>
                    <h5 title={category.name}>{renderText({
                        filterKey: "categoryId", 
                        compareValue: category.id, 
                        cellKey: "category",
                        value: category.name
                    })}</h5>
                </CategoryCell>
            </TDef>
            <TDef>
                <RoleCell {...propsForCell}>
                    <h5 title={role.name}>{renderText({
                        filterKey: "roleId", 
                        compareValue: role.id, 
                        cellKey: "role",
                        value: role.name
                    })}</h5>
                </RoleCell>
            </TDef>
            <TDef>
                <TDefContent {...propsForCell}>
                    <h5 title={creationDate}>{renderText({
                        value: creationDate
                    })}</h5>
                </TDefContent>
            </TDef>
            <TDef>
                <ActionsCell 
                    {...propsAdminActionsCell}
                    {...TDEF_CONTENT_PROPS}>
                    <CustomButton 
                        variant="terciary" 
                        icon={<EditIcon/>}
                        size="small"
                        width="40px"
                        onClick={() => openForm(userObj)}/>
                </ActionsCell>
            </TDef>
            <TDef>
                <ActionsCell 
                    {...propsAdminActionsCell}
                    {...TDEF_CONTENT_PROPS}>
                    <CustomButton 
                        variant="terciary" 
                        icon={<TrashIcon/>}
                        size="small"
                        width="40px"
                        onClick={() => openDialogForDeleteUser(userObj)}/>
                </ActionsCell>
            </TDef>
        </Container>
    );
}

export default TableListItem;